import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TeacherCommentAction } from '@textbook-api-client';
import { from, map, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {
  TextbookActionsHandler,
  TextbookActionsHandlerToken,
} from '../../../external/providers/textbook-actions-handler';
import { TextbookActionBase } from '../@base/textbook-action-base.model';
import { GroupInfo } from '../../models';

interface PlaceholderBounds {
  width: number;
  height: number;
}

@Component({
  selector: 'txtb-teacher-comment',
  templateUrl: './teacher-comment.component.html',
  styleUrls: ['./teacher-comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TeacherCommentComponent extends TextbookActionBase<TeacherCommentAction> implements OnInit {
  @Input() groupInfo!: GroupInfo;
  @ViewChild('wrapper') wrapper!: ElementRef;
  pagination = false;
  activeElementIndex = 0;
  images: HTMLImageElement[] = [];

  spinnerVisibility = true;

  placeHolderBounds: PlaceholderBounds = {
    width: 100,
    height: 100,
  };

  constructor(
    @Inject(TextbookActionsHandlerToken) public textbookActionsHandler: TextbookActionsHandler
  ) {
   super();
  }

  imageSrc: string[] = [];
  imageSrc$(resourceId: string, index: number): Observable<void> {
    if (this.imageSrc[index]) {
      return of(undefined);
    }
    return this.textbookActionsHandler.getResourceBlobAsString(resourceId).pipe(
      map((src) => {
        this.imageSrc[index] = src;
      })
    );
  }

  ngOnInit(): void {
    this.pagination = this.action.meta?.resourceIds?.length > 1;

    from(this.action.meta.resourceIds ?? [])
      .pipe(switchMap((resouceId) => this.textbookActionsHandler.getResourceUrl$(resouceId)))
      .subscribe((src) => {
        const image = new Image();
        image.src = src;
        this.images.push(image);
      });
  }

  onLoad(): void {
    this.spinnerVisibility = false;
  }

  changeElement(e: number): void {
    const { width, height } = this.wrapper.nativeElement.getBoundingClientRect();
    this.placeHolderBounds = { width, height };
    this.spinnerVisibility = true;
    this.activeElementIndex = e;
    this.scrollToTop();
  }

  scrollToTop(): void {
    this.wrapper.nativeElement.scroll(0, 0);
  }
}
